import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateLabelTemplate, LabelTemplate, LabelTemplateListResponse, LabelTemplateQueryParams, UpdateLabelTemplate } from '@frontend/label/types';

export class LabelTemplateClient extends APIClient {
    public static readonly endpoint = '/label-api/v1';

    public static async fetchLabelTemplates(queryParams?: ApiQueryParams<LabelTemplateQueryParams>): Promise<LabelTemplateListResponse> {
        return await this.apiPaginated<LabelTemplateListResponse, LabelTemplateQueryParams>(`${this.endpoint}/templates`, queryParams);
    }

    public static async resolveLabelTemplates(ids: string[], field: keyof LabelTemplate = 'id'): Promise<LabelTemplateListResponse> {
        const response = await this.post(`${this.endpoint}/templates-resolve`, { field, ids: ids });
        return await this.handleResponse<LabelTemplateListResponse>(response);
    }

    public static async deleteLabelTemplates(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/templates-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postLabelTemplate(accountId: string, body: CreateLabelTemplate): Promise<LabelTemplate> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/templates`, body);
        return await this.handleResponse<LabelTemplate>(response);
    }

    public static async fetchAccountLabelTemplate(accountId: string, templateId: string): Promise<LabelTemplate> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}`);
        return await this.handleResponse<LabelTemplate>(response);
    }

    public static async patchLabelTemplate(accountId: string, templateId: string, body: UpdateLabelTemplate): Promise<LabelTemplate> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/templates/${templateId}`, body);
        return await this.handleResponse<LabelTemplate>(response);
    }

    public static async deleteLabelTemplate(accountId: string, templateId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/templates/${templateId}`);
        return await this.handleVoidResponse(response);
    }
}
